export const DataMutationMyBag_ItemChangeQuantity_QueryKey = {
  mybagItemChangeQuantity: (): string => {
    const queryKey = "data-mutation-mybag-item-change-quantity";
    return queryKey;
  },
};
